import { Ng2StateDeclaration, Transition, UIRouterModule } from '@uirouter/angular';
import { PagePerformancePagesComponent } from '@client/app/modules/page-performance/pages/domain/pages/pages.component';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { StateService } from '@uirouter/core';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { SessionService } from '@monsido/core/session/session.service';
import {
    MonUIRouterTransitionService,
} from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { MON_MODULES } from '@monsido/core/constants/mon-modules.constant';
import { Component } from '@angular/core';

@Component({
    selector: 'base-page-performance',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BasePagePerformanceComponent {}

const hasAccess = [
    ActiveFeatureService,
    StateService,
    PipeService,
    SessionService,
    MonUIRouterTransitionService,
    Transition,
    function (
        ng2ActiveFeatureService,
        $state,
        pipeService: PipeService,
        ng2SessionService,
        ng2MonUIRouterTransitionService,
        transition: Transition,
    ) {
        if (
            ng2ActiveFeatureService.isFeatureActive('admin_page_performance') &&
            pipeService.get('hasAccess')(ng2SessionService.me, MON_MODULES.performance)
        ) {
            return Promise.resolve(true);
        }

        return ng2MonUIRouterTransitionService.onTransitionFinished(
            () => {
                $state.go('base.customer.domain.dashboard', transition.params());
            },
        );
    },
];

export const PAGE_PERFORMANCE_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.page-performance',
        url: '/page-performance',
        abstract: true,
        views: {
            'content@base.customer.domain': {
                component: BasePagePerformanceComponent,
            },
        },
        resolve: {
            hasAccess,
        },
    },
    {
        name: 'base.customer.domain.page-performance.pages',
        url: '/pages?showPage',
        params: {
            showPage: { dynamic: true },
        },
        views: {
            'content@base.customer.domain.page-performance': {
                component: PagePerformancePagesComponent,
            },

        },
        data: { title: 'Acquia Web Governance - Admin Page Performance Profiles' },
    },
];
